import { Box, Grid, Typography } from "@mui/material";
import React from "react";
import Copyright from "../../internals/components/Copyright";
import CustomerDepositReport from "../deposits/CustomerDepositReport";

const CustomerDeposit = ({ token, id, isAuthenticated, setIsAuthenticated }) => {
	return (
		<Box sx={{ width: "100%", maxWidth: { sm: "100%", md: "1700px" } }}>
			{/* cards */}
			<Typography component="h2" variant="h6" sx={{ mb: 2 }}>
				Customer Deposits
			</Typography>
			<Grid container columns={12}>
				<Grid size={{ xs: 12, md: 12, lg: 12 }}>
					<CustomerDepositReport token={token} id={id} isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated} />
				</Grid>
			</Grid>
			<Copyright sx={{ my: 4 }} />
		</Box>
	);
};

export default CustomerDeposit;
